import { render, staticRenderFns } from "./MyProjectOffers.vue?vue&type=template&id=1850dad4&scoped=true"
import script from "./MyProjectOffers.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyProjectOffers.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyProjectOffers.vue?vue&type=style&index=0&id=1850dad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1850dad4",
  null
  
)

export default component.exports